/* global window */

import Slick from 'vue-slick';
import debounce from 'lodash/debounce';
import bind from 'lodash/bind';

import './slick.scss';
import './CenterSlider.scss';
import template from './CenterSlider.vhtml';

const slickDefaults = {
	centerMode: true,
	arrows: false,
	slidesToShow: 3,
	slidesToScroll: 3,
	swipeToSlide: true,
};

export default {
	name: 'CenterSlider',
	template,
	components: { Slick },
	props: {
		slideGutter: {
			type: Number,
			default: 0,
		},
		slickOptions: {
			type: Object,
			default: {},
		},
		offsetWidth: {
			type: Number,
			default: 1440
		}
	},
	data: () => ({
		screenWidth: window.innerWidth,
		containerWidth: null,
	}),
	computed: {
		// Calculate the center padding to align the slick slider with the containing element
		centerPadding() {
			if (typeof this.containerWidth !== 'number') {
				return 0;
			}

			if(this.screenWidth > this.containerWidth && this.screenWidth < 1258){
				return 75 - this.slideGutter / 2
			}

			if(this.screenWidth < this.containerWidth && this.screenWidth >= 600){
				return 75 - this.slideGutter / 2
			}

			if(this.screenWidth < this.containerWidth && this.screenWidth < 600){
				return 35 - this.slideGutter / 2
			}


			return (
				(this.screenWidth - this.containerWidth) / 2 - this.slideGutter / 2
			);
		},
		slickOptionsComputed() {
			return {
				...slickDefaults,
				...this.slickOptions,
				centerPadding: `${this.centerPadding}px`,
			};
		},
	},
	watch: {
		// Re-init slick when options change
		slickOptionsComputed() {
			this.$nextTick(() => {
				this.$refs.slick.reSlick();
			});
		},
	},
	methods: {
		next() {
			console.log(this.$refs.slick)
			this.$refs.slick.next();
		},
		prev() {
			this.$refs.slick.prev();
		},
		goto(index){
			this.$refs.slick.goTo(index);
		},
		// Update the width of the screen and containing element
		updateContainerWidth() {
			this.containerWidth = this.offsetWidth;
			this.screenWidth = window.innerWidth;
		},
	},
	mounted() {
		// Update screen and container widths
		this.updateContainerWidth();

		// Create a debounced function for checking on resize
		this.$options.debouncedUpdateContainerWidth = debounce(
			bind(this.updateContainerWidth, this),
			200
		);

		// Add resize sniffer
		window.addEventListener(
			'resize',
			this.$options.debouncedUpdateContainerWidth
		);

		// Reslick initially to support v-for in the initial template
		this.$nextTick(() => {
			this.$refs.slick.reSlick();
		});
	},
	beforeDestroy() {
		// Remove resize sniffer
		window.removeEventListener(
			'resize',
			this.$options.debouncedUpdateContainerWidth
		);
	},
};
